import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import FlexRow from '../../../../molecules/FlexRow'
import { useDDPWealthJourneyEntryListState } from './DDPWealthJourneyEntryListContext'

const useStyles = makeStyles((theme) => ({
  pickerItem: {
    userSelect: 'none',
    fontWeight: theme.typography.weights.light,
    cursor: 'pointer',

    '&.__selected': {
      fontWeight: theme.typography.weights.bold,
      color: 'var(--color-primary-500)'
    }
  },
  pickList: {
    paddingLeft: theme.layout.padding.p10,
    paddingRight: theme.layout.padding.p10,
    '&:not(:first-child)': {
      borderLeft: '1px solid var(--color-neutral-700)'
    }
  }
}))

function YearPicker ({ className, style, years }) {
  const classes = useStyles()
  const { selectedYear, setSelectedYear } = useDDPWealthJourneyEntryListState()

  if (!years?.length) return null

  return (
    <FlexRow className={clsx('items-center justify-center', className)} style={style}>
      {years.map((year) => (
        <div key={year} className={classes.pickList}>
          <div
            role='button'
            className={clsx(classes.pickerItem, { __selected: selectedYear === year })}
            onClick={() => setSelectedYear(year)}
          >
            {year}
          </div>
        </div>
      ))}
    </FlexRow>
  )
}

YearPicker.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  years: PropTypes.arrayOf(PropTypes.string)
}

export default YearPicker
